// extracted by mini-css-extract-plugin
export default {"titleRow":"prognosisHeader_titleRow__TtnS6","badge":"prognosisHeader_badge__nZ-0t","pendingBadge":"prognosisHeader_pendingBadge__X8Z8U prognosisHeader_badge__nZ-0t"};